/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Image, Link } from 'components/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika est née en automne dans une ferme du canton de St-Gall, une exploitation familiale classique. Elle pèse 39 kilos. Les producteurs de lait suisses nourrissent en moyenne quelques 25 bêtes sur leur domaine (en comparaison: 187 aux USA).`}</p>
    <Image file={['rinderprobetrieb-fr-01.png', 'rinderprobetrieb-fr-02.png']} title='Nombre de bêtes par exploitation' subtitle='Moyenne 2018' source='Source: www.swissmilk.ch' mdxType="Image" />
    <p>{`On dénombre 1850 autres veaux nés le même jour qu’Erika - alors que presqu'autant de bœufs, de vaches et de veaux sont abattus (1725).`}</p>
    <Image file={'geburtenschlachtungen-fr.png'} title='Naissance et abattage par jour' subtitle='Moyenne quotidienne 2018' source='Source: www.identitas.ch' mdxType="Image" />
Dans les vingt-quatre heures suivant sa naissance, Erika est séparée de sa mère - cela se passerait de la même manière dans une ferme bio.
Cette méthode éprouvée vise à empêcher le veau de développer une relation étroite avec sa mère car une séparation plus tardive serait plus compliquée (<Link url='https://www.quarks.de/umwelt/tierwelt/so-stresst-die-fruehe-trennung-kalb-und-kuh/' mdxType="Link">plus de détails</Link>).
En outre, plus le petit veau tète sa mère, moins il y a de lait à vendre. L’option vache allaitante n’est pratiquée que dans 14% des cas en Suisse, une portion toujours réduite du cheptel bovin (<Link url='https://www.mutterkuh.ch/de/mutterkuh-schweiz/mutterkuhhaltung' mdxType="Link">plus de détails</Link>).
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  